module.exports = __webpack_public_path__ + "img/Banner-FLE-SP.a08c1b20.png";